import { SvgIconName } from '../../components/svg-icon/model';
import getFormatMessage from '../../locales/get-format-message';

export interface IPortalNavItem {
  readonly pathname: string;
  readonly name: string;
  readonly icon: SvgIconName;
  readonly iconHover: SvgIconName;
}

export const PORTAL_NAV_LIST: ReadonlyArray<IPortalNavItem> = [
  {
    pathname: '/studio/:studioId/portal',
    name: getFormatMessage('dev_portal'),
    icon: SvgIconName.StudioIcon,
    iconHover: SvgIconName.StudioIconHover,
  },
  {
    pathname: '/studio/:studioId/organization',
    name: getFormatMessage('organization'),
    icon: SvgIconName.OrgIcon,
    iconHover: SvgIconName.OrgIconHover,
  },
  {
    pathname: '/studio/:studioId/setting',
    name: getFormatMessage('setting_name'),
    icon: SvgIconName.SettingIcon,
    iconHover: SvgIconName.SettingIconHover,
  },
];

export const FEE_NAV = {
  pathname: '/studio/:studioId/fee/overview',
  name: getFormatMessage('billing'),
  icon: SvgIconName.BillingIcon,
  iconHover: SvgIconName.BillingIconHover,
};

export const AUDIT_HUB_NAV = {
  pathname: '/studio/:studioId/audithub',
  name: getFormatMessage('per_audit'),
  icon: SvgIconName.AuditHubIcon,
  iconHover: SvgIconName.AuditHubIconHover,
};
